import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var StringFormatClass;
function StringFormat() {
  if (StringFormatClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'StringFormat');
    StringFormatClass = $;
  }
  return StringFormatClass;
}
var BinaryFormatClass;
function BinaryFormat() {
  if (BinaryFormatClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'BinaryFormat');
    BinaryFormatClass = $;
  }
  return BinaryFormatClass;
}
//region block: exports
export {
  BinaryFormat as BinaryFormat3f3aelhmz0ro1,
  StringFormat as StringFormat2r2ka8mzcb3mi,
};
//endregion

//# sourceMappingURL=SerialFormat.mjs.map
